exports.components = {
  "component---src-pages-index-jsx": () => import("./../../../src/pages/index.jsx" /* webpackChunkName: "component---src-pages-index-jsx" */),
  "component---src-pages-odds-calculator-jsx": () => import("./../../../src/pages/odds-calculator.jsx" /* webpackChunkName: "component---src-pages-odds-calculator-jsx" */),
  "component---src-pages-pricing-b-jsx": () => import("./../../../src/pages/pricing-b.jsx" /* webpackChunkName: "component---src-pages-pricing-b-jsx" */),
  "component---src-pages-pricing-jsx": () => import("./../../../src/pages/pricing.jsx" /* webpackChunkName: "component---src-pages-pricing-jsx" */)
}

